import carcCodesJson from './carc-codes.json'
import prefixesJson from './prefixes.json'
import rarcCodesJson from './rarc-codes.json'

export interface RarcCode {
  code: string
  label: string
  description: string
}

export interface CarcCode {
  code: number
  label: string
  description: string
}

export interface PrefixCode {
  code: string
  label: string
}

export const carcCodes: CarcCode[] = carcCodesJson as CarcCode[]
export const rarcCodes: RarcCode[] = rarcCodesJson
export const prefixes: PrefixCode[] = prefixesJson
